import moment from "moment";

export function getSentBeeps({ timeline, moodboard }) {
  const item = { ...moodboard };
  let beepIds = [];
  const selectedBeeps = timeline?.sentBeeps
    .filter(
      ({ itemId, filterKey }) =>
        item.itemIds?.includes(itemId) || item.surveys?.includes(filterKey)
    )
    .sort((event1, event2) => event1.time - event2.time) ?? [{ time: 0 }];
  const getTime = () => {
    const minTime = selectedBeeps[0].time;
    const maxTime = selectedBeeps[selectedBeeps.length - 1].time;
    switch (item.view) {
      case "lastweeks":
        return moment(maxTime).subtract(1, "weeks").valueOf();
      case "last2weeks":
        return moment(maxTime).subtract(2, "weeks").valueOf();
      case "last4weeks":
        return moment(maxTime).subtract(4, "weeks").valueOf();
      default:
      case "alltime":
        return minTime;
    }
  };
  selectedBeeps.forEach((beep) => {
    // static board: fixed start and end time
    if (
      item.view === "custom" &&
      !item.update &&
      beep.time >= item.timeRange[0] &&
      beep.time <= item.timeRange[1]
    ) {
      beepIds.push(beep);
    }
    // half static board: fixed start time, no fixed end time (update to now)
    if (
      item.view === "custom" &&
      item.update &&
      beep.time >= item.timeRange[0]
    ) {
      beepIds.push(beep);
    }
    // dynamic board: no fixed start or end time (e.g., last2weeks, last4weeks, or alltime)
    if (item.view !== "custom" && item.update && beep.time >= getTime()) {
      beepIds.push(beep);
    }
  });
  return beepIds;
}

export default function getBeepIds({ timeline, moodboard }) {
  const item = { ...moodboard };
  let beepIds = [];
  const selectedBeeps = timeline?.events
    .filter(
      ({ itemId, filterKey }) =>
        item.itemIds?.includes(itemId) || item.surveys?.includes(filterKey)
    )
    .sort((event1, event2) => event1.time - event2.time) ?? [{ time: 0 }];
  const getTime = () => {
    const minTime = selectedBeeps[0].time;
    const maxTime = selectedBeeps[selectedBeeps.length - 1].time;
    switch (item.view) {
      case "lastweeks":
        return moment(maxTime).subtract(1, "weeks").valueOf();
      case "last2weeks":
        return moment(maxTime).subtract(2, "weeks").valueOf();
      case "last4weeks":
        return moment(maxTime).subtract(4, "weeks").valueOf();
      default:
      case "alltime":
        return minTime;
    }
  };
  selectedBeeps.forEach((beep) => {
    // static board: fixed start and end time
    if (
      item.view === "custom" &&
      !item.update &&
      beep.time >= item.timeRange[0] &&
      beep.time <= item.timeRange[1]
    ) {
      beepIds.push(beep.id);
    }
    // half static board: fixed start time, no fixed end time (update to now)
    if (
      item.view === "custom" &&
      item.update &&
      beep.time >= item.timeRange[0]
    ) {
      beepIds.push(beep.id);
    }
    // dynamic board: no fixed start or end time (e.g., last2weeks, last4weeks, or alltime)
    if (item.view !== "custom" && item.update && beep.time >= getTime()) {
      beepIds.push(beep.id);
    }
  });
  return beepIds;
}
